var exports = {
  "P": "x04b3a21e--a955cd--markup",
};

module.exports = exports;
